import HttpClient from "libs/utils/HttpClient";
import qs from "qs";

class AllDocumentsService {
  async getAllDocuments(body) {
    try {
      const params = qs.stringify({
        ...(body && body.personalId && { personalId: body.personalId }),
        ...(body && body.draftId && { draftId: body.draftId }),
        ...(body &&
          body.smartserviceId && { smartserviceId: body.smartserviceId }),
        ...(body &&
          body.typeDocSmartFromID && {
          typeDocSmartFromID: body.typeDocSmartFromID,
        }),
        ...(body && body.isBackend && { isBackend: body.isBackend }),
        ...(body && body.statausID && { statausID: body.statausID }),
      });
      const response = await HttpClient.get(
        `/api/visaformadmin/smartfrom/list?${params}`
      );

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getVisaValid(body) {
    try {
      const params = qs.stringify({
        draftId: body.draftId,
      });
      const response = await HttpClient.get(`/api/visa/valid?${params}`);

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getPersonalSO(body) {
    try {
      const params = qs.stringify({
        personalID: body.personalID,
      });

      const response = await HttpClient.get(
        `/api/stamp/personalo/list?personalID=${body?.params}`
      );

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }
  async getStampDetailPersonalSO(body) {
    try {
      const params = qs.stringify({
        personalID: body.personalID,
      });

      const response = await HttpClient.get(
        `/api/stampo/list?personalID=${body?.params}`
      );

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async viewDoc(draftId) {
    try {
      const response = await HttpClient.post(
        `/api/visaformadmin/smartfrom/view`,
        { draftId: draftId }
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async approveDoc(body) {
    try {
      const response = await HttpClient.post(
        `/api/visaformadmin/smartfrom/boiapprove`,
        body
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async CheckProLog(body) {
    try {
      const response = await HttpClient.post(
        `/api/visaformadmin/checkpropertieslog/add`,
        body
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async Departmentupload(body) {
    try {
      const response = await HttpClient.post(
        `/api/visaformadmin/configsmartdepartmentupload/add`,
        { detail: body }
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async forceApprove(body) {
    try {
      const response = await HttpClient.post(
        `/api/visaformadmin/smartfrom/froce`,
        body
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async otherApproveDoc(body) {
    try {
      const response = await HttpClient.post(
        `/api/visaformadmin/smartfrom/otherapprove`,
        body
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async healthinsuranceApprove(body) {
    try {
      const response = await HttpClient.post(
        `/api/visaformadmin/healthinsurance/approve`,
        body
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async boiapproveex(body) {
    try {
      const response = await HttpClient.post(
        `/api/visaformadmin/smartfrom/boiapproveex`,
        body
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async boirecieved(body) {
    try {
      const response = await HttpClient.post(
        `/api/visaformadmin/smartfrom/boireceived`,
        body
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }
  async checkproperties(body) {
    try {
      const response = await HttpClient.get(
        `/api/visaformadmin/checkpropertiesdep/list?departmentId=${body}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async returndraft(body) {
    try {
      const response = await HttpClient.post(
        `/api/visaform/smartfrom/returndraft`,
        body
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async rejectDoc(body) {
    try {
      const response = await HttpClient.post(
        `/api/visaformadmin/smartfrom/reject`,
        body
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }
  async ReasonOtherDep(body) {
    try {
      const response = await HttpClient.post(
        `/api/visaformadmin/reason/otherdep`,
        body
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async completetDoc(body) {
    try {
      const response = await HttpClient.post(
        `/api/visaformadmin/smartfrom/boiapproveex`,
        body
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }
  async undo(body) {
    try {
      const response = await HttpClient.post(
        `/api/visaformadmin/smartfrom/cancelapprove`,
        body
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async otherUndo(body) {
    try {
      const response = await HttpClient.post(
        `/api/visaformadmin/smartfrom/cancelapproveotherdep`,
        body
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async downloadDocDetail(draftId) {
    try {
      const response = await HttpClient.getBlob(
        `/api/report/resultsmartfrom?draftId=${draftId}`
      );
      return response;
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async downloadLongResidentVisaTH(draftId) {
    try {
      const response = await HttpClient.getBlob(
        `/api/report/ReportNotificationLongResidentVisaTH?draftId=${draftId}`
      );
      return response;
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async downloadNotificationPassLongVisaDWPTH(draftId) {
    try {
      const response = await HttpClient.getBlob(
        `/api/report/ReportNotificationPassLongVisaDWPTH?draftId=${draftId}`
      );
      return response;
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async downloadTerminate(draftId) {
    try {
      const response = await HttpClient.getBlob(
        `/api/report/terminate?draftId=${draftId}`
      );
      return response;
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async downloadChange(draftId) {
    try {
      const response = await HttpClient.getBlob(
        `/api/report/change?draftId=${draftId}`
      );
      return response;
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async requestDocuments(body) {
    try {
      const response = await HttpClient.post(
        `/api/visaformadmin/smartfrom/reqdoc/add`,
        body
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async reassignDoc(body) {
    try {
      const response = await HttpClient.post(
        `/api/visaformadmin/smartfrom/reassign`,
        body
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async consultDoc(body) {
    try {
      const response = await HttpClient.post(
        `/api/visaformadmin/smartfrom/sendmanager`,
        body
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async superaccessList(body) {
    try {
      const params = qs.stringify({
        ...(body && body.draftId && { draftId: body.draftId }),
        ...(body && body.departmentId && { departmentId: body.departmentId }),
      });
      const response = await HttpClient.get(
        `/api/visaformadmin/superaccess/list?${params}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async superaccessremove(body) {
    try {
      const response = await HttpClient.post(
        `/api/visaformadmin/superaccess/remove`,
        body
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async docLogs(body) {
    try {
      const params = qs.stringify({
        ...(body && body.draftId && { draftId: body.draftId }),
        ...(body && body.departmentId && { departmentId: body.departmentId }),
      });
      const response = await HttpClient.get(
        `/api/visaformadmin/logsmartfrom/list?${params}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async translateDoc(body) {
    try {
      const params = qs.stringify({
        ...(body && body.smartId && { smartId: body.smartId }),
        ...(body && body.languageCode && { languageCode: body.languageCode }),
        ...(body &&
          body.translateCode && { translateCode: body.translateCode }),
      });
      const response = await HttpClient.get(`/api/translate/read?${params}`);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async cancelSmartForm(body) {
    try {
      const response = await HttpClient.post(
        `/api/visaform/smartfrom/delete`,
        body
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async confirmStamp(body) {
    try {
      const response = await HttpClient.post(`/api/stamp/confirm`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async requestDocsHealthInsurance(body) {
    try {
      const response = await HttpClient.post(
        `/api/visaformadmin/healthinsurance/requiredoc`,
        body
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async approveHealthinsurance(body) {
    try {
      const response = await HttpClient.post(
        `/api/visaformadmin/healthinsurance/approve`,
        body
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  // ใบ Report Quadepartment
  async getReportquadepartment(body) {
    try {
      const params = qs.stringify({
        ...(body && body.departmentId && { departmentId: body.departmentId }),
        ...(body && body.draftId && { draftId: body.draftId }),
      });
      const response = await HttpClient.getBlob(
        `/api/report/quadepartment?${params}`
      );
      return response;
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }
}

export default new AllDocumentsService();
